import React from 'react';
import './PolicyPage.css';

const ShippingReturns: React.FC = () => (
  <main className="policy-page">
    <h1>Shipping & Returns</h1>
    <p className="policy-updated">Last updated: September 23, 2026</p>
    <h2>Shipping</h2>
    <ul>
      <li><strong>Zaria and Kaduna:</strong> estimated delivery within 24 hours.</li>
      <li><strong>Outside Zaria and Kaduna:</strong> estimated delivery within 1–3 days.</li>
      <li><strong>Shipping fee:</strong> Shipping is free. A minimum order value of ₦15,000 is required to place an order. Delivery estimates are not guaranteed deadlines. Please provide a complete and reachable delivery address and phone number.</li>
    </ul>
    <h2>Returns</h2>
    <p>Contact us as soon as possible after delivery if an item is damaged, incorrect, incomplete, or otherwise has an issue. Keep the item, packaging, accessories, and proof of purchase until we provide instructions.</p>
    <p>Return eligibility depends on the item condition, reason for return, product category, and applicable terms. Do not send an item back without receiving return instructions.</p>
    <h2>Return Shipping</h2>
    <p>The buyer bears return shipping costs based on prevailing market rates, unless Gimbiya Value Store confirms a different arrangement in writing.</p>
    <h2>Manufacturer Warranty</h2>
    <p>Warranty coverage is available only where provided by the manufacturer and is subject to the manufacturer's terms and conditions.</p>
    <p>Contact <a href="mailto:hello@gimbiyastore.com">hello@gimbiyastore.com</a> for help.</p>
  </main>
);
export default ShippingReturns;
